var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ComConfig", {
    attrs: {
      title: "商城-1",
      component_name: "9-1-goods",
      limit: 1,
      configItemId: 4,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }